// /*
// * used for displaying password input value
// * just add "init-show-hide-password" directive to switcher element
// */
angular
    .module('app')
    .directive('dropdownHour', DropdownHour);

DropdownHour.$inject = [];
function DropdownHour() {
    function getHours(){
        var hours = [];
        for (var i = 0; i < 24; i++) {
            hours.push({v: i, t: (i<10?'0':'') +  i+':00'});
        }
        return hours;
    }
    return {
        restrict: 'A',
        scope: {
            ngModel: '=',
            ngDisabled: '=',
        },
        link: function(scope, element, attrs){
            scope.hours = getHours();
        },
        template:   '<select class="form-control"  ng-model="ngModel" ng-disabled="ngDisabled" ng-options="h.v as h.t for h in hours"></select>'
    };
}
